const SELLING_PLAN_ID_INPUT = document.getElementById('mmSellingPlanId');
const SELLING_PLAN_OPTIONS = document.querySelectorAll('.mm-selling-plan-option');
const SUBSCRIPTION_LABELs = document.querySelectorAll('.mm-rc-subscription-label');

function mmSubscriptionMethodChanged(selected_selling_method) {
  const method = selected_selling_method.value;

  if(method == 'one_time') {
    SELLING_PLAN_ID_INPUT.value = "";
    SELLING_PLAN_OPTIONS.forEach(function(sellingPlanOption) {
      sellingPlanOption.checked= false;
    })
    SUBSCRIPTION_LABELs.forEach(function(SUBSCRIPTION_LABEL) {
      SUBSCRIPTION_LABEL.classList.remove('mm-open');      
    })
  } else {
    const plan_selected = document.querySelector('.mm-selling-plan-option:checked');
    if (plan_selected) {
      SELLING_PLAN_ID_INPUT.value = plan_selected.value;         
    } else {
      SELLING_PLAN_OPTIONS[0].checked = true;
      SELLING_PLAN_ID_INPUT.value = SELLING_PLAN_OPTIONS[0].value;      
    }
    SUBSCRIPTION_LABELs.forEach(function(SUBSCRIPTION_LABEL) {
      SUBSCRIPTION_LABEL.classList.add('mm-open');
    })
  }

  // get new price
  const price_html_elem = selected_selling_method.nextElementSibling.querySelector('.mm-rc-price').innerHTML;
  // put new price in CTA
  const CTAs = document.querySelectorAll('.mm-main-product-cta');
  CTAs.forEach(function(CTA) {
    if(CTA.querySelector('.mm-product-price')) {
      CTA.querySelector('.mm-product-price').innerHTML = price_html_elem;      
    }
  })
}

function syncRcElements(clickedLabel) {
  const inputValue = clickedLabel.value;
  const elems = document.querySelectorAll(`.mm-selling-plans-elem input[value="${inputValue}"]`);
  elems.forEach(function(elem) {
    elem.click();
  })
}

function mmSubscriptionPlanChanged(selected_selling_plan) {
  const selected_selling_plan_id = selected_selling_plan.value;

  SELLING_PLAN_ID_INPUT.value = selected_selling_plan_id;
}

document.addEventListener("DOMContentLoaded", function () {
	// Récupérer l'élément actuellement sélectionné
	const selectedSellingMethod = document.querySelector('input[name="purchase_option"]:checked');

  console.log('selectedSellingMethod', selectedSellingMethod)

	// Vérifier si un élément est sélectionné et appeler la fonction
	if (selectedSellingMethod) {
		mmSubscriptionMethodChanged(selectedSellingMethod);
	}
});
